<template>
    <div class="navq hnavq" id="nav">
        <div class="w">
            <div class="lcat">
                <p class="nall">全部商品分类</p>
                <ul class="lnav" id="lnav">
                    <li v-for="(item,index) in cate" :key="item.id"   @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)">
                        <div style="line-height: 38px;">
                            <em class="f"><i :class="item.icon" style="font-size:20px;"></i></em>
                            <div>
                                <a class="lma" href="javascript:;" @click="catesearch(item.title,index)">{{item.title}}</a>
                                <div>
                                    <div v-for="(it,its) in item.z.slice(0,3)" :key="it.id"  style="float:left;padding-left:10px;">
                                        <router-link :to="{path:'/shop/shopsearch', query:{cate_id:it.id}}" target="_blank">
                                            <p class="lmap">{{it.title}}</p>
                                        </router-link>
                                        <span class="sss" style="padding:0 6px;" v-if="its == 0 && its == 1">/</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="lra"  v-show="isActive || n != index">
                            <div class="lh3">
                                <b class="left">{{item.title}}</b>
                            </div>
                            <div class="bo_icn over">
                                <div v-for="it in item.z" :key="it.id">
                                    <router-link :to="{path:'/shop/shopsearch', query:{cate_id:it.id}}" target="_blank" class="b_aa">
                                        <img width="45" height="45" class="c_img" :src="it.piclink">
                                        <p>{{it.title}}</p>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <pc-top-menu></pc-top-menu>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
import Topmenu from "@/components/common/top-menu"
export default{
    components:{
		'pc-top-menu': Topmenu
	},
    data(){
        return{
            n: 999,
            // index:0,
            active:"",
            isActive: false,
            //全部商品分类
            cate: [],
            type: 1,
            //分类图标
            icon : [
                {icon:"iconfont icon-nanxing"},
                {icon:"iconfont icon-nvxing"},
                {icon:"iconfont icon-anquantaobiyuntao"},
                {icon:"iconfont icon-nvyongqiju-tiaodan"},
                {icon:"iconfont icon-diaodai"},
                {icon:"iconfont icon-tehui"},
            ]
        }
    },
    mounted() {
        this.getShopCate();
    },
    methods:{
        //获取所有商品分类
        getShopCate() {
            this.$api.getCategory.getShopCate({}).then(res => {
                if (res.code == 200) {
                    this.cate = [];
                    var arr = res.result.cate;
                    arr.forEach((item,index) => {
                        if (item.show == 1) {
                            item.icon=this.icon[index].icon
                            this.cate.push(item);
                        }
                    });
                    this.type = res.result.types;
                }
            });
        },
        onMouseOver($event){
            $event.currentTarget.className="con";
            this.isActive = false;
        },
        onMouseOut($event){
            $event.currentTarget.className="";
            this.isActive = true;
        },
        catesearch(title,index){
            if(index == 0){
                this.$router.push(`/woman/`);
            }else if(index == 1){
                this.$router.push(`/man/`);
            }else if(index == 2){
                this.$router.push(`/biyuntao/`);
            }else if(index == 3){
                this.$router.push(`/zhuxing/`);
            }else if(index == 4){
                this.$router.push(`/lingleiwanju/`);
            }else if(index == 5){
                this.$router.push(`/tehui/`);
            }
        }
    }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/menu.vue